module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-night4.d8b5b3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-night4.png
// module id = 8My6
// module chunks = 0